import React from "react";
import filter from "mn-utils/filter";

import withState from '../../../../utils/withState';
import {Box, CircularProgress, Grid} from "@material-ui/core";
import ButtonBack from "../../../dumb/Button/BackB";
import {backLocation, pushLocation} from "../../../../router";
import Caption from "../../../dumb/Caption/C";
import ButtonDownload from "../../../dumb/Button/DownloadA";
import {
  DisplayIdMerchant,
  DisplayDataMerchant,
  DisplayAmountMerchant,
  DisplayDateDetailedMerchant
} from "../../../helpers/Display/DataDisplay";
import {
  DetailedDataPrimaryDisplay,
  DetailedDataSecondaryDisplay, DetailedDataSecondaryItem
} from "../../../helpers/Display/DetailedData";
import {DisplayHashMerchant} from "../../../dumb/DisplayData";
import upperFirst from "mn-utils/upperFirst";
import Divider from "@material-ui/core/Divider";
import {LINK_PBL, LINK_TRANSACTION_REFUND} from "../../../../constants/links";
import RefundList from "../Refund/RefundList";
import openPopupCancel from './openPopupCancel';
import {BtnRedFilled, BtnBlueFilled} from "../../../helpers/Buttons";

import {apiV2PayByLinkDetails} from "../../../../api/merchant/payByLink";
import generatePBLReceipt from "./utils/generatePBLReceipt";
import toEllipsisMiddle from "../../../../utils/toEllipsisMiddle";
import handleDBItemData from "./utils/handleDBItemData";
import {router$} from "../../../../emitters/router";
import {MerchantPageHeader} from "../../../helpers/Display";
import {PageHeaderId} from "../../../helpers/Typography";

const TrxDetailsHeader = ({invoiceNumber, handlePrint}) => {
  const routingParams = (((router$.getValue() || {}).location || {}).query || {});
  const backFN = routingParams.pblIsNew
    ? () => pushLocation({path: LINK_PBL})
    : backLocation;

  return (
    <MerchantPageHeader
      title="Transaction details"
      backFN={backFN}
      leftBlock={(
        <Box ml="2rem">
          <PageHeaderId>
            {invoiceNumber}
          </PageHeaderId>
        </Box>
      )}
      rightBlock={(
        <ButtonDownload
          onClick={handlePrint}
          name="Download Receipt"
        />
      )}
    />
  )
}

const TrxDetailsPrimaryData = ({data}) => {
  const itemsParamsList = [
    {
      titleHandler: ({buyerName}) => buyerName,
      dataHandler: ({email}) => (
        <DisplayDataMerchant>{email}</DisplayDataMerchant>
      )
    },
    {
      titleHandler: ({company}) => company,
      dataHandler: ({address}) => (
        <DisplayDataMerchant>{address}</DisplayDataMerchant>
      )
    },
  ];

  return (
    <DetailedDataPrimaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
    />
  )
};
const TrxDetailsSecondaryData = ({data}) => {

  const itemsParamsList = [
    {
      title: 'Order ID',
      dataHandler: ({orderId}) => (
        <DisplayIdMerchant>{orderId}</DisplayIdMerchant>
      )
    },
    {
      title: 'Transaction hash',
      dataHandler: ({hash, network, currencyCode}) => (
        <DisplayHashMerchant
          symbol={currencyCode}
          network={network}
          hash={hash}
        />
      )
    },
    {
      title: 'Amount (fiat)',
      dataHandler: ({fiatAmount, fiatCode}) => (
        <DisplayAmountMerchant
          amount={fiatAmount}
          symbol={fiatCode}
          type="fiat"
        />
      )
    },
    {
      title: 'Amount (crypto)',
      dataHandler: ({currencyAmount, currencyCode}) => (
        <DisplayAmountMerchant
          amount={currencyAmount}
          symbol={currencyCode}
          type="coin"
        />
      )
    },
    {
      title: 'Network',
      skip: ({network, cryptoCurrencyCode, BPaySymbol}) => {
        return !network || cryptoCurrencyCode === BPaySymbol;
      },
      key: 'network'
    },
    {
      title: 'Fee',
      dataHandler: ({retailerFeeAmount, feeCode}) => (
        <DisplayAmountMerchant
          amount={retailerFeeAmount}
          symbol={feeCode}
          type="fiat"
        />
      )
    },
    {
      title: 'Order date and time',
      dataHandler: ({timeOfInvoice}) => (
        <DisplayDateDetailedMerchant date={timeOfInvoice} />
      )
    },
    {
      title: 'Due date and time',
      dataHandler: ({timeOfExpiration}) => (
        <DisplayDateDetailedMerchant date={timeOfExpiration} />
      )
    },
    {
      title: 'Phone',
      dataHandler: ({phone}) => (
        <DisplayDataMerchant>{phone}</DisplayDataMerchant>
      )
    },
    {
      title: 'Status',
      dataHandler: ({status}) => (
        <div
          className={`cC4C4C4.expired c2CE889.paid c5B47FF.sent cEE4F4F.cancelled ` + status}
        >
          {upperFirst(status)}
        </div>
      )
    },
  ]

  return (
    <DetailedDataSecondaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
      additionalItems={(
        <Grid item xs={12}>
          <DetailedDataSecondaryItem
            title="Description"
            value={data.desc || '-'}
          />
        </Grid>
      )}
    />
  )
};

export default withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  const updateData = () => {
    const params = self.props.params || {};

    apiV2PayByLinkDetails(filter({
      id: params.id,
      auction_id: params.auction_id,
    })).then(handleDBItemData).then((data) => setState({data, loading: false}));
  }

  onMount(() => {
    updateData();
  });

  const handlePrint = () => {
    setState({
      loading: true,
    });

    generatePBLReceipt(self.state.data || {})
        .finally(() => {
          setState({
            loading: false,
          });
        });
  }

  return (state) => {
    if (state.loading) {
      return (
        <Box>
          <CircularProgress size="2.5rem" color="inherit" />
        </Box>
      )
    }

    const data = state.data || {};

    const {
      invoiceNumber,

      orderId,
      paymentId,

      refundsList,
      refundableAmount,
      status,
    } = data;

    const hasCancel = status === 'sent';

    return (
      <>
        <TrxDetailsHeader invoiceNumber={invoiceNumber} handlePrint={handlePrint} />
        <Box mt="3.5rem">
          <TrxDetailsPrimaryData data={data} />
        </Box>
        <Box mt="3rem" mb="4.5rem">
          <Divider />
        </Box>
        <Box>
          <TrxDetailsSecondaryData data={data} />
        </Box>
        {hasCancel && (
          <Box maxWidth="30rem" mt="4.5rem">
            <BtnRedFilled
              onClick={() => openPopupCancel(data, updateData)}
            >
              Cancel
            </BtnRedFilled>
          </Box>
        )}
        {!!refundsList.length && (
          <RefundList
            orderId={orderId}
            items={refundsList}
            callback={updateData}
          />
        )}
      </>
    )
  }
})
